export default __webpack_public_path__ + "static/aaron-bitmoji-864277e423633e752f676ba864629ec5.png";